import { useContext } from 'react'
import { FormStateContext } from '../context/FormStateContext'

const useFormState = () => useContext(FormStateContext)

export default useFormState
